import { useNetworkStatus } from "@radianse/components";
import { Box, Text, Flex, Icon, Heading } from "@chakra-ui/react";
import React from "react";
import { WifiIcon } from "@heroicons/react/solid";
import { ExclamationCircleIcon } from "@heroicons/react/outline";

export const NetworkStatus = ({ children }) => {
  const { online } = useNetworkStatus();

  if (!online) {
    return (
      <Flex
        justifyContent={"center"}
        flex={1}
        justify={"center"}
        direction={"column"}
        alignItems={"center"}
      >
        <Box position={"relative"} h={20} w={20} mb={4}>
          <Icon
            as={WifiIcon}
            h={20}
            w={20}
            position={"absolute"}
            color={"whiteAlpha.700"}
          ></Icon>
          <Icon
            as={ExclamationCircleIcon}
            h={6}
            w={6}
            position={"absolute"}
            bottom={0}
            right={0}
            color={"red.600"}
          ></Icon>
        </Box>
        <Heading as={"h1"} mb={4}>
          Kiosk Offline
        </Heading>
        <Text>
          Network connection interrupted. Please see a staff member for
          assistance.
        </Text>
      </Flex>
    );
  }
  return <>{children}</>;
};
